import ImageOne from '../../../images/WNP시스템.png';
import ImageTwo from '../../../images/관리자.png';
import ImageThree from '../../../images/설치.png';


export const InfoSectionData = {
	id: 'about',
	lightBg: false,
	lightText: true,
	lightTextDesc: true,
	topLine: '쉐어플러그는 WNP(WITHOUT NETWORK PAY)시스템과 OTP(ONE TINE PASSWORD). 시스템을 통하여 "도전 방지"가 가능한 "콘센트 이용" 서비스를 제공합니다',
	headLine: '쉐어플러그란?',
	description: 'WNP 시스템을 적용한 ',
  bolddes: '스마트한 콘센트 이용 서비스',
	buttonLabel: 'Get started',
	imgStart: false,
	img: ImageOne,
	alt: 'car',
	dark: true,
	primary: true,
	darkText: false,
  topLine2: '개별 충전기를 콘센트에 꼽아 충전하는 모든 모빌리티의 충전 방식은 쉐어플러그로 충전이 가능합니다.',
	headLine2: '쉐어플러그란?',
	description2: '모든 기기의 충전이 가능한 ',
  bolddes2: '광범위한 콘센트 이용 서비스',
	img2: ImageTwo,
  topLine3: '쉐어플러그는 부담없이 설치와 운영이 가능하기 때문에, 빠르게 사용 지역을 늘려가고 있습니다.',
	headLine3: '쉐어플러그란?',
	description3: '주위에서 쉽게 찾을 수 있는 ',
  bolddes3: '접근이 쉬운 콘센트 이용 서비스',
	img3: ImageThree
};

export const HowtoSectionData = {
	id: 'about',
	lightBg: false,
	lightText: true,
	lightTextDesc: true,
	description: '플러그 개수 파악, 구매',
  bolddes: '쉐어플러그 구매',
	imgStart: false,
	dark: true,
	primary: true,
	darkText: false,
	description2: '직접 플러그 설치, 브라켓 고정',
  bolddes2: '쉐어플러그 설치',
	description3: '관리자 페이지 등록, 월별 정산',
  bolddes3: '쉐어플러그 등록',
};

